import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_RUNNING_API

//axios.defaults.headers.common['Authorization'] = { withCredentials: true}